<template>
	<!-- 工作日报 -->
	<div>
		<div class="search_wrap">
			<el-form
				:model="queryParam"
				ref="form"
				label-width="80px"
				:inline="true"
				size="mini"
			>
				<el-form-item label="用户电话">
					<el-input
						@keyup.enter.native="searchQuery"
						v-model="queryParam.phone"
						placeholder="请输入"
					></el-input>
				</el-form-item>

				<el-form-item>
					<el-button type="primary" @click="searchQuery">查询</el-button>
					<el-button type="default" @click="searchReset">重置</el-button>
					<el-button size="mini" type="primary" @click="handleAdd()">新增</el-button
					>
					<el-popconfirm
						style="margin-left: 10px"
						title="确定发布吗？"
						@confirm="grounding(1)"
					>
						<template #reference>
							<el-button size="mini" type="success">发布</el-button>
						</template>
					</el-popconfirm>
					<el-popconfirm
						style="margin-left: 10px"
						title="确定撤销发布吗？"
						@confirm="grounding(0)"
					>
						<template #reference>
						<el-button size="mini" type="warning">撤销发布</el-button>
						</template>
					</el-popconfirm>
				</el-form-item>
			</el-form>
		</div>

		<e-table
			:listLoading="loading"
			:selection="true"
			:tableHeadConfig="columns"
			@pageChange="loadData"
			:paginationData="ipagination"
			:tableLoadData="dataSource"
			@selectLine="onSelectChange"
			:tableRowClassName="tableRowClassName"
		>
			<template #type="slotData">
				<p>
					{{
						slotData.data.row.type == 1
							? '轮播'
							: slotData.data.row.type == 2
							? '瓦力课堂'
							: ''
					}}
				</p>
			</template>
			<template #isPublish="slotData">
				<p>
					{{
						slotData.data.row.isPublish == 1
							? '是'
							: slotData.data.row.isPublish == 0
							? '否'
							: ''
					}}
				</p>
			</template>
			<template #picUrl="slotData">
				<el-image
				v-if="slotData.data.row.picUrl"
				style="width: 100px; height: 50px"
				:src="slotData.data.row.picUrl"
				:preview-src-list="[slotData.data.row.picUrl]"
				:key="slotData.data.row.id"
				>
				<div
					slot="error"
					class="image-slot"
					style="width: 100px; height: 50px"
				>
					<img
					src="@/assets/imgFail.png"
					alt
					style="width: 60px; height: 40px"
					/>
				</div>
				</el-image>
				<span style="color: gray" v-else>暂无</span>
			</template>
			<template #handlerSlot="slotData">
				<el-button
				size="mini"
				type="success"
				@click="handleDetail(slotData.data.row, true)"
				>详情</el-button
				>
			</template>
		</e-table>
    <modal-form ref="modalForm" @ok="modalFormOk"></modal-form>
	</div>
</template>

<script>
import { httpAction } from '@/api/manage';
import modalForm from "./component/userModal";
import eTable from '@/components/table';
import { listMixin } from '@/mixins/listMixin';
import { convertTime } from '@/utils/util';
export default {
	components: { eTable, modalForm },
	mixins: [listMixin],
	data() {
		return {
			inspectionDate: '',
			dateDefaultShow: '',
			expireTimeOption: {
				disabledDate(date) {
					return date.getTime() >= Date.now();
				},
			},
			url: {
				list: '/wlImageText/queryPage',
				isPublish: '/wlImageText/isPublish',
			},
			//字段权限
			loading: false,
			queryParam: {},
			columns: [
				{ field: 'type', label: '类型', slotName: 'type', columnType: 'slot' },
				{
					field: 'isPublish',
					label: '是否发布',
					slotName: 'isPublish',
					columnType: 'slot',
				},
				{ field: 'title', label: '标题' },
				{ field: 'picUrl', label: '图片', slotName: 'picUrl', columnType: 'slot' },
				{ field: 'linkUrl', label: '公众号链接' },
				{ field: 'content', label: '内容' },
				{ field: 'publishTime', label: '发布时间' },
				{
				width: 160,
				label: "编辑",
				slotName: "handlerSlot",
				columnType: "slot",
				},
			],
		};
	},
	updated() {},
	mounted() {
		this.dataSource.forEach(
			(item) => item.subscribeTime && convertTime(item.subscribeTime)
		);
		this.dateDefaultShow = new Date();
		this.dateDefaultShow.setMonth(new Date().getMonth() - 1);
	},
	methods: {
		dateChange(date) {
			this.queryParam.inspectionDateStart = date[0] + ' 00:00:00';
			this.queryParam.inspectionDateEnd = date[1] + ' 23:59:59';
		},
		clockwiseImg() {},
		searchReset() {
			this.queryParam = {};
			this.inspectionDate = '';
			this.searchQuery();
		},
		grounding(type) {
		if (this.selectedRowKeys && this.selectedRowKeys.length > 0) {
			let ids = [];
			this.selectedRowKeys.forEach((item) => {
			ids.push(item);
			});
			httpAction(this.url.isPublish, {ids, isPublish: type }, "post").then((res) => {
			if (res.code === 200) {
				this.$message.success("操作成功");
				this.loadData(1);
			} else {
				this.$message.error(res.msg);
			}
			});
		} else {
			this.$message.warning("请选择后操作");
		}
		},
	},
};
</script>

<style scoped lang="less">
.search_wrap {
	margin: 10px 0;
}

.selectBox {
	margin-bottom: 18px;
	display: inline-block;
	margin-right: 10px;
	vertical-align: top;
}
.selectText {
	width: 80px;
	line-height: 28px;
	font-weight: 700;
	cursor: default;
	float: none;
	display: inline-block;
	text-align: right;
	vertical-align: middle;
	font-size: 14px;
	color: #606266;
	padding: 0 12px 0 0;
	box-sizing: border-box;
}

.cursorStyle {
	cursor: pointer;
}

.images {
	display: none;
}
</style>
